import script from "./Navigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./Navigation.vue?vue&type=script&setup=true&lang=ts"

import "./Navigation.vue?vue&type=style&index=0&id=14a889e9&lang=less&scoped=true"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14a889e9"]])

export default __exports__